import React from 'react'
import SAMUEL_CV from '../../Assets/SAMUEL_CV.pdf'

const Action = () => {
  return (
    <div className='Action'>
        <a href={SAMUEL_CV} download className='btn'> Download Cv </a>
        <a href='#contact' className='btn btn-primary'> Let's Talk </a>
    </div>
  )
}

export default Action